import React, { ReactNode, useMemo } from 'react';
import { Field } from 'react-final-form';

import { ValidationMessage } from '@xsolla/ui-core';

import { FlexParentBlock, SpaceBetweenBlock } from '../../../styled';
import NumberInput from '../NumberInput';
import { Props as InputProps } from '../NumberInput/types';
import {
  ExtraFieldLink,
  FieldInputTitle,
  FullWideContentBlock,
  InputSubLabel,
  InputSubLabelCompact
} from './style';

type Props = InputProps & {
  label?: ReactNode;
  extraRight?: ReactNode;
  additional?: ReactNode;
  subLabel?: ReactNode;
  subLabelCompact?: boolean;
  extraLink?: {
    title: ReactNode;
    to: string;
  };
  name: string;
  dataTestId?: string;
};

const FieldInputNumber = ({
  label,
  extraRight,
  errorMessage,
  name,
  additional,
  subLabel,
  subLabelCompact = false,
  extraLink,
  dataTestId,
  ...props
}: Props): JSX.Element => {
  const renderSubLabel = useMemo(() => {
    if (subLabelCompact) {
      return <InputSubLabelCompact>{subLabel}</InputSubLabelCompact>;
    }

    return <InputSubLabel>{subLabel}</InputSubLabel>;
  }, []);

  return (
    <div data-test-id={dataTestId}>
      <SpaceBetweenBlock>
        <FieldInputTitle>{label}</FieldInputTitle>
        {additional && <div>{additional}</div>}
      </SpaceBetweenBlock>
      <FlexParentBlock>
        <FullWideContentBlock>
          <Field name={name}>
            {({ input }) => (
              <>
                <NumberInput
                  name={input.name}
                  value={input.value}
                  onChange={(e) => {
                    input.onChange(e.target.value || null);
                  }}
                  {...props}
                />

                {subLabel && renderSubLabel}

                {extraLink && (
                  <ExtraFieldLink href={extraLink.to} target="_blank">
                    {extraLink.title}
                  </ExtraFieldLink>
                )}
                <ValidationMessage>{errorMessage}</ValidationMessage>
              </>
            )}
          </Field>
        </FullWideContentBlock>
        {extraRight}
      </FlexParentBlock>
    </div>
  );
};

export default FieldInputNumber;
